import { useQuery } from '@apollo/client';
import { GET_LISTING_AVERAGE_SELLING_TIME_FOR_BRAND_NAMES } from 'apollo-client/queries/getListingAverageSellingTimeForBrandNames';
import { HorizontalBarGraph } from 'components/HorizontalBarGraph';
import { GetListingAverageSellingTimeForBrandNamesRequest, Query } from 'generated/graphql';
import { useIntl } from 'react-intl';

export const SellingTimeForBrandNamesChart: (p: { vendorNames: Array<string> }) => JSX.Element | null = ({
  vendorNames,
}) => {
  const { formatMessage } = useIntl();
  const { loading, data } = useQuery<Query, GetListingAverageSellingTimeForBrandNamesRequest>(
    GET_LISTING_AVERAGE_SELLING_TIME_FOR_BRAND_NAMES,
    { variables: { vendorNames } }
  );
  return (
    <HorizontalBarGraph
      loading={loading}
      color="PRIMARY"
      barSeriesName={formatMessage({ id: 'averageSellingTimeForBrandNames' })}
      title={formatMessage({ id: 'averageSellingTimeForBrandNames' })}
      data={
        data?.getListingAverageSellingTimeForBrandNames?.map(({ brandName, sellingTimeInDays }) => ({
          x: brandName,
          y: sellingTimeInDays,
        })) || []
      }
    />
  );
};
